import React, { useCallback, useState, useMemo } from 'react';

import { Form, FormControl, FormGroup, Glyphicon } from 'react-bootstrap';

import Modal from '../../utils/ModalComponet';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import { Order } from '../../../types/Order';

const cancellOptions = [
  { value: 'vendor-canceled', label: 'Vendor canceled' },
  { value: 'customer-mistake', label: 'Customer mistakenly placed order' },
  {
    value: 'availability-issue',
    label: 'Customer’s timeslot not available & could not find alternative',
  },
  {
    value: 'booked-direct-with-vendor',
    label: 'Customer booked directly with the vendor',
  },
  {
    value: 'availability-issue-calendar-out-of-date',
    label: 'Customer time unavailable - Calendar out of date',
  },
  { value: 'vendor-unresponsive', label: 'Vendor Unresponsive' },
  { value: 'test-booking', label: 'Test Booking' },
  { value: 'other', label: 'Other (Leave comment)' },
];

const cancelFulfilledOptions = [
  { value: 'vendor-cancelled', label: 'Vendor Cancelled' },
  { value: 'customer-cancelled', label: 'Customer Cancelled' },
  {
    value: 'availability-issue-calendar-out-of-date',
    label: 'Customer time unavailable - Calendar out of date',
  },
  { value: 'vendor-unresponsive', label: 'Vendor Unresponsive' },
  { value: 'other', label: 'Other (Notes Required)' },
];

type Props = {
  onClose: () => void;
  onPress: (reason: string, reasonNote: string, isClose?: boolean) => void;
  order: Order | null;
  updateOrder?: () => void;
};
const OrderCancellationModal = ({
  onClose,
  onPress,
  order = null,
  updateOrder,
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [reasonNote, setReasonNote] = useState<string>('');

  const { status } = order ?? {
    status: null,
  };

  const onChangeReasonNote = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setReasonNote(e.currentTarget.value),
    [setReasonNote]
  );
  const [reason, setReason] = useState<string | undefined>(undefined);

  const buttonEnabled = useMemo(() => {
    let valid = true;
    if (reason === 'other' && reasonNote.trim().length === 0) {
      valid = false;
    }
    return reason !== undefined && !loading && valid;
  }, [loading, reason, reasonNote]);

  const isFulfilled = status === 'Fulfilled';

  const options = isFulfilled ? cancelFulfilledOptions : cancellOptions;

  const submitCancel = useCallback(async () => {
    setLoading(true);
    onPress(reason as string, reasonNote, isFulfilled);
    updateOrder && updateOrder();
    setLoading(false);
  }, [isFulfilled, onPress, reason, reasonNote, updateOrder]);

  return (
    <Modal open closeModal={onClose}>
      <h4>Cancel Order</h4>
      <Form>
        <FormGroup>
          <p>Select a reason for cancelling the order.</p>
          <SimpleSelect
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            value={reason}
            onChange={setReason}
            data={options}
            targetBody={false}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            label='Reason Notes'
            placeholder='Add any additional details here.'
            onChange={onChangeReasonNote}
            value={reasonNote}
            componentClass='textarea'
          />
        </FormGroup>
        <button
          disabled={!buttonEnabled}
          className='btn btn-primary'
          type='button'
          onClick={submitCancel}
        >
          Cancel order
        </button>
        {loading && (
          <Glyphicon
            key={0}
            glyph='refresh'
            className='spinning'
            style={{ fontSize: '14px' }}
          />
        )}
      </Form>
    </Modal>
  );
};

export default OrderCancellationModal;
